import { toJS } from 'mobx';
export const shoppingItemTypes = [{
  type: 'course',
  buildShoppingItems: item => [item]
}, {
  type: 'bundle',
  buildShoppingItems: item => {
    const courses = toJS(item.buyable.courses);
    const updatedCourses = [];
    courses.forEach(course => {
      const courseAsItem = {
        ...course
      };
      courseAsItem.buyable = course;
      updatedCourses.push(courseAsItem);
    });
    return updatedCourses;
  }
}, {
  type: 'gift',
  buildShoppingItems: item => {
    const updatedItem = toJS(item);
    updatedItem.buyable = updatedItem.buyable.course;
    return [updatedItem];
  }
}, {
  type: 'license',
  buildShoppingItems: item => {
    const updatedItem = toJS(item);
    updatedItem.buyable = updatedItem.buyable.course;
    return [updatedItem];
  }
}, {
  type: 'certification_voucher',
  buildShoppingItems: item => {
    const updatedItem = toJS(item);
    updatedItem.buyable = updatedItem.buyable;
    return [updatedItem];
  }
}];
//# sourceMappingURL=shopping-item-types.js.map